import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import moment from "moment";
import AdminDiamondReportService from "../../services/reports-AdminDiamond-service";
import { Spin } from "antd";
import Chart from "react-google-charts";
import { chartColors } from "../reports/colors";

const AdminDiamondCertificateIndComp = ({
  globalDiamonds,
  mainForDealer,
  isApplyFilter,
  pageNo,
  pageSize,
  sortOrderCol,
  sortOrderType,
  setPageNo,
  handleGetDiamondCertificateList,
  setTableCertificateValue,
  setPaginationPage,
  chartData,
  setColorData, 
  options,
  setChartData,
  colorData,
}) => {
  const { t } = useTranslation();

  const [dealerId, setDealerId] = useState();
  const loginDetials = useSelector((state) => state.loginReducer);
  const [LoadChartReportsLoading, setLoadChartReportsLoading] = useState(false);

  

  // Configuration
  const MAX_ENTRIES = 15; // Maximum slices to show

 
  
  useEffect(() => {
    if (loginDetials?.loginDetials?.responseData?.logInSucceeded) {
      setDealerId(loginDetials.loginDetials.responseData.dealerId);
      handleLoadChartReports(
        loginDetials.loginDetials.responseData.dealerId,
        mainForDealer
      );
    }
  }, [isApplyFilter]);

  // Process chart data with max entries limit
  const processChartData = (searchesList) => {
    if (!searchesList?.length) {
      return { chartData: [], colors: [] };
    }

    // Filter out zero values and sort by count (descending)
    const filteredData = searchesList.filter(item => item.CNT > 0);
    const sortedData = [...filteredData].sort((a, b) => b.CNT - a.CNT);

    // Apply max entries limit
    const topData = sortedData.slice(0, MAX_ENTRIES);
    const remainingData = sortedData.slice(MAX_ENTRIES);

    // Calculate "Others" if needed
    const othersValue = remainingData.reduce((sum, item) => sum + item.CNT, 0);
    if (othersValue > 0 && remainingData.length > 0) {
      topData.push({
        Certificate: t("Others"),
        CNT: othersValue,
        isOthers: true
      });
    }

    // Calculate total for percentages
    const total = topData.reduce((sum, item) => sum + item.CNT, 0);

    // Prepare chart data
    const processedChartData = [["Certificate", "Count"]];
    const colors = [];

    topData.forEach((item, index) => {
      const percentage = total > 0 ? ((item.CNT / total) * 100).toFixed(1) : 0;
      const color = chartColors[index % chartColors.length];
      colors.push(color);
      
      processedChartData.push([`${item.Certificate} (${percentage}%)`, item.CNT]);
    });

    return { chartData: processedChartData, colors };
  };

  const handleLoadChartReports = (dealerId, forDealer) => {
    let inputData = {
      dealerID: dealerId.toString(),
      forDealer: forDealer ? forDealer.toString() : "",
      fromDate: globalDiamonds.dataRangeFrom
        ? moment(globalDiamonds.dataRangeFrom).format("YYYY-MM-DD")
        : "2020-08-17",
      toDate: globalDiamonds.dataRangeTo
        ? moment(globalDiamonds.dataRangeTo).format("YYYY-MM-DD")
        : "2022-09-15",
      retailerIds: globalDiamonds.retailerIds.toString(),
      vendorIds: globalDiamonds.vendorIds.toString(),
      selectedDiamondValue: globalDiamonds.SelectedDiamondValue,
      type: "Global",
      reportName: "Certificate",
    };
    
    setLoadChartReportsLoading(true);
    
    AdminDiamondReportService.LoadChartReports(inputData)
      .then((response) => {
        if (response.data.message === "Success" && response.data.responseData?.DiamondCertificateSearches) {
          const searchesList = response.data.responseData.DiamondCertificateSearches;
          
          // Process data with max entries limit
          const { chartData: processedData, colors } = processChartData(searchesList);
          setChartData(processedData);
          setColorData(colors);
        } else {
          setChartData([]);
          setColorData([]);
        }
      })
      .catch((error) => {
        setChartData([]);
        setColorData([]);
      })
      .finally(() => setLoadChartReportsLoading(false));
  };

  const handleClick = ({ chartWrapper }) => {
    const chart = chartWrapper.getChart();
    const selection = chart.getSelection();
    if (selection.length > 0) {
      const selectedItem = selection[0];
      const label = chartData[selectedItem.row + 1][0];
      const result = label.split(" (")[0];
      // Update parent state to trigger table refresh
      if (setTableCertificateValue) {
        setTableCertificateValue(result);
      }
      if (setPaginationPage) {
        setPaginationPage(1);
      }
    }
  };

  return (
    <React.Fragment>
      <div className="col-lg-12 mt-4">
        <label>
          <b>{t("Diamond Certificate Searches")}</b>
        </label>
        
        <Spin spinning={LoadChartReportsLoading} size="large">
          {chartData.length > 1 ? (
            <>
              {/* Custom Legend */}
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  justifyContent: "center",
                  marginBottom: "10px",
                }}
              >
                {chartData.slice(1).map((row, index) => (
                  <div
                    key={index}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      margin: "4px 8px",
                      fontSize: "13px",
                      fontWeight: "500",
                    }}
                  >
                    <div
                      style={{
                        width: "14px",
                        height: "14px",
                        backgroundColor: colorData[index],
                        marginRight: "6px",
                        borderRadius: "3px",
                      }}
                    ></div>
                    {row[0].replace(/\s*\([^)]*\)\s*/g, "")} ({row[1]})
                  </div>
                ))}
              </div>

              {/* Centered Doughnut Chart */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  width: "100%",
                }}
              >
                <Chart
                  chartType="PieChart"
                  data={chartData}
                  width={window.innerWidth > 500 ? "800px" : "320px"}
                  height={window.innerWidth > 500 ? "500px" : "300px"}
                  options={options}
                  chartEvents={[
                    {
                      eventName: "select",
                      callback: handleClick,
                    },
                  ]}
                />
              </div>
            </>
          ) : (
            <div className="no-report-render">
              <div className="desc-space">
                <h4 className="text-center">{t("No Data Found")}</h4>
              </div>
            </div>
          )}
        </Spin>
      </div>
    </React.Fragment>
  );
};

export default AdminDiamondCertificateIndComp;